import Chart from 'chart.js/auto';

document.addEventListener('DOMContentLoaded', () => {
    // Check if any elements with class 'block--kuchendiagramm' exist
    const chartContainers = document.querySelectorAll('.block--kuchendiagramm');

    if (chartContainers.length > 0) {
        // Find all canvases with class 'kuchendiagramm-chart'
        const chartCanvases = document.querySelectorAll('.kuchendiagramm-chart');

        chartCanvases.forEach(canvas => {
            const ctx = canvas.getContext('2d');
            // Get chart data from data-chart attribute
            const chartData = JSON.parse(canvas.dataset.chart);

            const labels = chartData.map(item => item.bezeichnung);
            const values = chartData.map(item => item.wert);
            const colors = chartData.map(item => item.farbwahl);

            new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: labels,
                    datasets: [{
                        data: values,
                        backgroundColor: colors,
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            display: false // Disable default legend
                        },
                        title: {
                            display: false,
                        },
                        tooltip: {
                            callbacks: {
                                title: function() {
                                    return ''; // Remove the tooltip title
                                },
                                label: function(context) {
                                    let label = context.label || '';
                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.raw !== null) {
                                        label += context.raw.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
                                    }
                                    return label;
                                }
                            }
                        }
                    }
                }
            });
        });
    }
});